/**
 * PostgreSQL btree index limit is 2704 bytes. tsvector size ≈ input chars × 1.7 bytes
 * (stemmed English text). Safe total input ≈ 1500 chars (1500 × 1.7 = 2550, with buffer).
 * Content gets weight 'A' and is the primary field, so it gets the larger share.
 *
 */
export const MEMORY_CONTENT_MAX_LENGTH = 1000;
export const MEMORY_CONTEXT_MAX_LENGTH = 500;
